<button class="scroll-to-top" *ngIf="isVisible" (click)="scrollToTop()" aria-label="Scroll to top">
  <img src="../../../../assets/icons/up-arrow.svg" alt="Scroll Up" />
</button>
